import { useQuery } from "@tanstack/react-query";
import { listRoles } from "../../api/staff";
import { useServices } from "../../app/services";
import { useScope } from "../classes/common";

/** `GET /roles` needs `roles.roles_view`. Without it only the caller's own role name is known (from `/me`). */
export function useRoleNames() {
  const { client } = useServices();
  const sc = useScope();
  const enabled = sc.ctx.has("roles.roles_view");
  const q = useQuery({ queryKey: ["roles", ...sc.key], queryFn: () => listRoles(client), enabled, retry: false });
  const names = new Map((q.data ?? []).map((r) => [r.id, r.name]));
  const me = sc.ctx.me;
  if (me && !names.has(me.staff.roleId)) names.set(me.staff.roleId, me.staff.roleName);
  return { roles: q.data ?? [], names, canPick: enabled, pending: enabled && q.isPending, error: q.error, refetch: q.refetch, nameOf: (id: string) => names.get(id) ?? null };
}
